import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation markAttendedMutation($input: markAttendedInput!){
        markAttended(input:$input) {
          attendee{
            id
            fullName
            email
            phone
            additionalGuests
            status
            crmUrl
            isResident
            attended
            rsvpCancelReason
          }
        }
      }
      `;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;